import { directive as vClickOutside } from "vue-clickaway";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install(Vue) {
        Vue.directive("click-outside", vClickOutside);

        Vue.directive("disable-all", function (el, binding) {
            var disable = binding.value;//false = enabling cref: https://stackoverflow.com/questions/55905055/vue-need-to-disable-all-inputs-on-page
            var tabIndex = disable ? -1 : 0; //TODO:TD post this as an answer on the SO above. 

            const tags = ["input", "button", "textarea", "select"];
                tags.forEach(tagName => {
                    const nodes = el.getElementsByTagName(tagName);
                    for (let i = 0; i < nodes.length; i++) {
                        nodes[i].disabled = disable;
                        nodes[i].tabIndex = tabIndex;
                    }
                });
            });
  }
};

export default GlobalDirectives;
